/* eslint-disable import/prefer-default-export */
export const getUserInfo = (state) => (
  state.currentUser.userInfo ? state.currentUser.userInfo : {});

export const getUserAuthenticationStatus = (state) => !!state.currentUser.userInfo.email;
